import type { ReactElement } from 'react';
import type { CustomColumns, CustomColumnsProps } from './CustomColumns';
import type { MultiLevelSorting } from './MultiLevelSorting';
import type {
  CollectionViewsDropdown,
  CollectionViewsDropdownProps,
} from './CollectionViewsDropdown';
import type { FiltersMap } from '@wix/bex-core';
import {
  ReorderModeToolbar,
  ReorderModeToolbarBaseProps,
} from './CollectionToolbar';

export type CustomColumnsElement = ReactElement<
  CustomColumnsProps,
  typeof CustomColumns
>;

export type MultiLevelSortingElement = ReactElement<
  {},
  typeof MultiLevelSorting
>;

export type CollectionViewsDropdownElement<F extends FiltersMap> = ReactElement<
  CollectionViewsDropdownProps<F>,
  typeof CollectionViewsDropdown
>;

export type ReorderModeToolbarElement = ReactElement<
  ReorderModeToolbarBaseProps,
  typeof ReorderModeToolbar
>;

export function assertComponentType(
  element: ReactElement | null | undefined | boolean,
  displayName: string,
  propName: string,
) {
  if (
    element === true ||
    (element &&
      (element.type as { displayName?: string }).displayName !== displayName)
  ) {
    throw new Error(`Prop "${propName}" must be a <${displayName} /> element`);
  }
}
